// Shared language config for the multilingual Guest Guide (IT/EN/FR/DE).
export const GUEST_LANGS = [
  { code: "it", native: "Italiano", flag: "🇮🇹" },
  { code: "en", native: "English", flag: "🇬🇧" },
  { code: "fr", native: "Français", flag: "🇫🇷" },
  { code: "de", native: "Deutsch", flag: "🇩🇪" },
];

export const LANG_NATIVE = { it: "Italiano", en: "English", fr: "Français", de: "Deutsch" };
export const LANG_FLAG = { it: "🇮🇹", en: "🇬🇧", fr: "🇫🇷", de: "🇩🇪" };
export const LANG_SHORT = { it: "IT", en: "EN", fr: "FR", de: "DE" };
